'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _restaurantsTripadvisorProxyClient = require('@wix/restaurants-tripadvisor-proxy-client');

exports.default = function (query) {
    var tripadvisorApi = new _restaurantsTripadvisorProxyClient.TripadvisorProxyClient({ XMLHttpRequest: XMLHttpRequest });
    return tripadvisorApi.api({ query: query });
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/TripadvisorApiConnector.js
// module id = 1035
// module chunks = 0